// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetQuestionExtractionsByCallIdParam,
    BaseResponseQuestionExtractionFoundResponse,
} from '../../types';

/**
 * 热门问题详情
 *
 * @export
 * @tags 热门问题抽取
 * @link [GET] /questionExtractions/{callId}
 * @param callId
 */
export function getQuestionExtractionsByCallId(
    options: ApiOptions<GetQuestionExtractionsByCallIdParam, never> & {
        segments: GetQuestionExtractionsByCallIdParam;
    }
): Promise<BaseResponseQuestionExtractionFoundResponse> {
    return request<never, GetQuestionExtractionsByCallIdParam, never>(
        '/questionExtractions/{callId}',
        { ...options, method: 'get', __$requestCalleeName: 'getQuestionExtractionsByCallId' }
    );
}

export const meta = [
    { tags: ['热门问题抽取'], path: '/questionExtractions/{callId}', method: 'get' },
];
